"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVidyardReady = exports.imageSizes = exports.getThumbnailSrc = exports.getThumbnailAlt = exports.getReactPlayerClassName = exports.getModalClassName = exports.deployModalOnEnter = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Video.scss");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _useVideo = require("../../utils/hooks/useVideo");
var _fpoSquare = _interopRequireDefault(require("../../images/fpo-square.png"));
var _removeSpaces = require("../../utils/removeSpaces");
var _play = _interopRequireDefault(require("../../images/play.svg"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _VidyardModal = _interopRequireDefault(require("../VidyardModal/VidyardModal"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _reactPlayer = _interopRequireDefault(require("react-player"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const isVidyardReady = (video, modalDeployed) => {
  return video && video?.vidyard && modalDeployed && typeof window !== "undefined";
};
exports.isVidyardReady = isVidyardReady;
const deployModalOnEnter = (event, mouse, deployModal) => {
  if (!mouse) {
    if (event.keyCode === 13) {
      deployModal();
    }
  }
};
exports.deployModalOnEnter = deployModalOnEnter;
const getReactPlayerClassName = (vidyard, modalDeployed) => {
  return `luna-super-hero__video-wrapper ${vidyard ? "luna-super-hero__video-wrapper--vidyard" : "luna-super-hero__video-wrapper--default"} ${modalDeployed ? "luna-super-hero__video-wrapper--is-deployed" : "luna-super-hero__video-wrapper--is-hidden"}`;
};
exports.getReactPlayerClassName = getReactPlayerClassName;
const getModalClassName = modalDeployed => {
  return `luna-super-hero__modal ${modalDeployed ? "luna-super-hero__modal--is-deployed" : "luna-super-hero__modal--is-hidden"}`;
};
exports.getModalClassName = getModalClassName;
const getThumbnailSrc = (thumbnail, removeSpaces, fpoSquare) => {
  return thumbnail?.src ? removeSpaces(thumbnail?.src) : fpoSquare;
};
exports.getThumbnailSrc = getThumbnailSrc;
const getThumbnailAlt = thumbnail => {
  return thumbnail?.alt || "placeholder image";
};
exports.getThumbnailAlt = getThumbnailAlt;
const closeModalOnEscape = (event, hideModal) => {
  if (event?.keyCode === 27) {
    hideModal();
  }
};
const imageSizes = {
  variant_1: {
    desktop: {
      width: 800,
      height: 400,
      ratio: {
        width: 2,
        height: 1
      }
    },
    tablet: {
      width: 720,
      height: 400,
      ratio: {
        width: 9,
        height: 5
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_2: {
    desktop: {
      width: 560,
      height: 560,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 720,
      height: 720,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 320,
      height: 320,
      ratio: {
        width: 1,
        height: 1
      }
    }
  },
  variant_3: {
    desktop: {
      width: 800,
      height: 360,
      ratio: {
        width: 20,
        height: 9
      }
    },
    tablet: {
      width: 720,
      height: 400,
      ratio: {
        width: 9,
        height: 5
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_4: {
    desktop: {
      width: 480,
      height: 480,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 720,
      height: 720,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 320,
      height: 320,
      ratio: {
        width: 1,
        height: 1
      }
    }
  },
  variant_5: {
    desktop: {
      width: 1440,
      height: 700,
      ratio: {
        width: 72,
        height: 35
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_6: {
    desktop: {
      width: 1280,
      height: 490,
      ratio: {
        width: 16,
        height: 7
      }
    },
    tablet: {
      width: 720,
      height: 420,
      ratio: {
        width: 12,
        height: 7
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_7: {
    desktop: {
      width: 721,
      height: 406,
      ratio: {
        width: 16,
        height: 9
      }
    },
    tablet: {
      width: 720,
      height: 420,
      ratio: {
        width: 12,
        height: 7
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_8: {
    desktop: {
      width: 720,
      height: 720,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 360,
      height: 220,
      ratio: {
        width: 3,
        height: 2
      }
    }
  },
  variant_9: {
    desktop: {
      width: 720,
      height: 480,
      ratio: {
        width: 3,
        height: 2
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 360,
      height: 220,
      ratio: {
        width: 3,
        height: 2
      }
    }
  },
  variant_10: {
    desktop: {
      width: 960,
      height: 650,
      ratio: {
        width: 1.48,
        height: 1
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 360,
      height: 220,
      ratio: {
        width: 3,
        height: 2
      }
    }
  },
  unbounded_cards: {
    desktop: {
      width: 272,
      height: 181,
      ratio: {
        width: 3,
        height: 2
      }
    },
    tablet: {
      width: 395,
      height: 254,
      ratio: {
        width: 14,
        height: 9
      }
    },
    mobile: {
      width: 600,
      height: 400,
      ratio: {
        width: 3,
        height: 2
      }
    }
  }
};
exports.imageSizes = imageSizes;
const useFocus = modalDeployed => {
  (0, _react.useEffect)(() => {
    const focusOnModal = () => {
      if (typeof document !== "undefined") {
        const modal = document.getElementById("video-modal");
        if (modal) {
          modal.focus();
        }
      }
    };
    const removeFocus = () => {
      if (typeof document !== "undefined") {
        const modal = document.getElementById("video-modal");
        if (modal) {
          modal.blur();
        }
      }
    };
    if (modalDeployed) {
      focusOnModal();
    }
    return () => {
      removeFocus();
    };
  }, [modalDeployed]);
};
const renderVideo = function (video, thumbnail, hovering, modalDeployed, playing, deployModal, hideModal, setHovering, togglePlaying, image, content, transcriptVisable, setTranscriptVisable, transcript, transcriptText, closeTranscript, videoProgress) {
  let setVideoProgress = arguments.length > 17 && arguments[17] !== undefined ? arguments[17] : () => {};
  let override = arguments.length > 18 ? arguments[18] : undefined;
  let setOverride = arguments.length > 19 ? arguments[19] : undefined;
  let setVisible = arguments.length > 20 ? arguments[20] : undefined;
  const [isPaused, setIsPaused] = (0, _react.useState)(false);
  const [playedSeconds, setPlayedSeconds] = (0, _react.useState)(0);
  const player = (0, _react.useRef)(_react.default.ReactPlayer);
  if (video && thumbnail && !image && modalDeployed) {
    let type;
    if (content?.video?.url?.includes("youtube") && !content?.video?.uuid) {
      type = "youtube";
    } else if (content?.video?.url?.includes("vimeo") && !content?.video?.uuid) {
      type = "vimeo";
    } else if (content?.video?.uuid && !content?.video?.url) {
      type = "vidyard";
    }
    return /*#__PURE__*/_react.default.createElement("section", {
      id: "video-modal",
      tabIndex: -1,
      className: getModalClassName(modalDeployed),
      style: {
        overflow: transcript && transcriptText ? "scroll" : "hidden"
      },
      onClick: () => {
        if (!transcript) {
          hideModal();
        }
      },
      onKeyUp: event => {
        closeModalOnEscape(event, hideModal);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "luna-super-hero__video-close-wrapper",
      onClick: event => {
        if (type === "youtube" || type === "vimeo") {
          setVideoProgress({
            type: type,
            eventType: event,
            playedSeconds,
            video_action: isPaused ? "paused" : "on-going",
            length: player?.current?.getDuration(),
            title: content?.video?.videoTitle
          });
        }
        if (override) {
          setOverride(false);
          if (setVisible) {
            setVisible(false);
          }
        }
        hideModal();
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: "#ffffff",
      type: "ter-icon--open-x-dark-48px",
      size: "32px",
      className: "luna-super-hero__close-button"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: getReactPlayerClassName(content?.vidyard, modalDeployed)
    }, content?.video && !content?.video?.vidyard && modalDeployed && /*#__PURE__*/_react.default.createElement(_reactPlayer.default, {
      ref: player,
      url: content.video.url,
      onProgress: videoProgress => {
        setVideoProgress({
          type: type,
          ...videoProgress,
          video_action: isPaused ? "paused" : "on-going",
          length: player?.current?.getDuration(),
          title: content?.video?.videoTitle
        });
        setPlayedSeconds(videoProgress?.playedSeconds);
      },
      width: "100%",
      height: "100%",
      playing: playing,
      controls: true,
      onStart: () => {
        togglePlaying(true);
      },
      onPlay: videoProgress => {
        setIsPaused(false);
        togglePlaying(true);
        setVideoProgress({
          type: type,
          eventType: event,
          playedSeconds,
          video_action: "playing",
          length: player?.current?.getDuration(),
          title: content?.video?.videoTitle
        });
      },
      onPause: videoProgress => {
        setIsPaused(true);
        togglePlaying(false);
      },
      onEnded: () => {
        togglePlaying(false);
      },
      onError: () => {
        togglePlaying(false);
      },
      allowFullScreen: true
    }), isVidyardReady(video, modalDeployed) && typeof window !== "undefined" && _VidyardModal.default && /*#__PURE__*/_react.default.createElement(_VidyardModal.default, {
      video: content?.video,
      videoProgress: videoProgress,
      setVideoProgress: setVideoProgress,
      type: type,
      setIsPaused: setIsPaused,
      isPaused: isPaused
    }), transcript && transcriptText && /*#__PURE__*/_react.default.createElement("div", {
      className: `luna-super-hero__transcript-wrapper luna-super-hero__transcript-wrapper--${isVidyardReady(video, modalDeployed)}`
    }, transcript && !transcriptVisable && /*#__PURE__*/_react.default.createElement("p", {
      className: "luna-super-hero__transcript-title",
      onClick: () => setTranscriptVisable(!transcriptVisable)
    }, transcript), closeTranscript && transcriptVisable && /*#__PURE__*/_react.default.createElement("p", {
      className: "luna-super-hero__transcript-title",
      onClick: () => setTranscriptVisable(!transcriptVisable)
    }, closeTranscript), transcriptVisable && transcriptText && /*#__PURE__*/_react.default.createElement("p", {
      className: "luna-super-hero__transcript-body"
    }, transcriptText))));
  } else {
    return;
  }
};
const thumbnailContainer = (video, thumbnail, hovering, modalDeployed, playing, deployModal, hideModal, setHovering, togglePlaying, image, content, variant, mouse, override) => {
  if (override) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  if (video && thumbnail && !image) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `luna-super-hero__thumbnail-container luna-super-hero__thumbnail-container-${variant}`,
      tabIndex: mouse ? "" : "0",
      onKeyDown: e => deployModalOnEnter(e, mouse, deployModal)
    }, /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
      className: `luna-super-hero__thumbnail ${hovering ? "luna-super-hero__thumbnail--is-hovering" : ""}`,
      onClick: () => deployModal(),
      onMouseOver: () => setHovering(true),
      onMouseLeave: () => setHovering(false),
      focalPointImage: thumbnail?.focalPointImage ? thumbnail?.focalPointImage : {
        // leaving x and y as 0 will center the image
        x: 0,
        y: 0,
        height: imageSizes[variant]?.desktop?.height,
        width: imageSizes[variant]?.desktop?.width,
        url: getThumbnailSrc(thumbnail, _removeSpaces.removeSpaces, _fpoSquare.default)
      },
      alt: (0, _generateFocusedImageAlt.default)(thumbnail) !== "" ? (0, _generateFocusedImageAlt.default)(thumbnail) : getThumbnailAlt(thumbnail, _removeSpaces.removeSpaces),
      fullHeightWrapper: true,
      imageSizes: imageSizes[variant]
    }), /*#__PURE__*/_react.default.createElement("img", {
      onClick: () => deployModal(),
      onMouseOver: () => setHovering(true),
      onMouseLeave: () => setHovering(false),
      src: _play.default,
      alt: "play button",
      className: `luna-super-hero__play-btn ${hovering ? "ter-hero-play-btn--is-hovering" : ""}`
    }));
  } else {
    return;
  }
};
const VideoComponent = _ref => {
  let {
    content,
    override = false,
    setOverride = () => {}
  } = _ref;
  const {
    transcript,
    closeTranscript,
    transcriptText,
    video,
    image,
    thumbnail,
    variant,
    videoProgress,
    setVideoProgress,
    setVisible = () => {}
  } = content;
  const {
    hovering,
    modalDeployed,
    playing,
    deployModal,
    hideModal,
    setHovering,
    togglePlaying
  } = (0, _useVideo.useVideo)(false, false, override);
  if (override && !modalDeployed) {
    deployModal();
  }
  const [transcriptVisable, setTranscriptVisable] = (0, _react.useState)(false);
  const {
    mouse
  } = (0, _useMouse.default)();
  useFocus(modalDeployed);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${modalDeployed ? "videoContainer videoContainer--deployed" : "videoContainer"}`,
    "data-sb-object-id": video?.contentfulId
  }, thumbnailContainer(video, thumbnail, hovering, modalDeployed, playing, deployModal, hideModal, setHovering, togglePlaying, image, content, variant, mouse, override), renderVideo(video, thumbnail, hovering, modalDeployed, playing, deployModal, hideModal, setHovering, togglePlaying, image, content, transcriptVisable, setTranscriptVisable, transcript, transcriptText, closeTranscript, videoProgress, setVideoProgress, override, setOverride, setVisible));
};
var _default = VideoComponent;
exports.default = _default;